const previewFontSize = `16px`
const previewFontSizeMobile = `14px`
const previewFontWeight = 400

module.exports = {
  previewFontSize,
  previewFontSizeMobile,
  previewFontWeight,
}
